import { createSlice } from '@reduxjs/toolkit';
import { positionAdapter } from '../../resources/Position.resource';
var initialState = {
    data: []
};
export var PositionReducer = createSlice({
    name: 'position',
    initialState: initialState,
    reducers: {
        setPosition: function setPosition(state, action) {
            state.data = action.payload.map(function (item) {
                return positionAdapter(item);
            });
        },
        clearPosition: function clearPosition(state) {
            state.data = [];
        }
    }
});
var _PositionReducer$acti = PositionReducer.actions, setPosition = _PositionReducer$acti.setPosition, clearPosition = _PositionReducer$acti.clearPosition;
export { setPosition, clearPosition };
export default PositionReducer.reducer;
